<div class="side-padding sm:px-0">
  <div class="bg-white rounded-10 p-5 max-sm:p-3 pb-0 max-sm:pb-0">
    <app-breadcrumbs
      [infoBreadcrumb]="{
        sport: 'Sports.Football',
        icon: 'Futbol',
        name: 'Sports.Favorites' | translate,
        logo: ''
      }"
    ></app-breadcrumbs>

    <div
      class="bg-scores bg-top w-full h-238 rounded-10 max-sm:rounded-5 max-sm:h-81 flex text-white items-center px-10 max-sm:px-3 gap-5 max-sm:gap-3"
    >
      <img
        alt="favorites"
        class="w-[150px] h-[158px] p-4 max-sm:p-2 max-sm:w-[57px] max-sm:h-[57px] rounded-full object-contain"
        [src]="urlIMG + 'favorites.png'"
      />

      <h1 class="font-inter-600 text-32 max-sm:text-14 text-white">
        {{ "MyFavorites" | translate }}
      </h1>
    </div>

    <div class="pt-4 max-sm:pt-2"></div>
    <app-favorite-tab-bar (valueTap)="handleFavoriteTab($event)" />
    <!-- <app-tab-bar
      [selectedIndex]="selectedIndex"
      filtersOptions="favorites"
      (selectedIndexChange)="menuSelected($event)"
    ></app-tab-bar> -->
  </div>

  <div class="pt-4 max-sm:pt-2">
    @switch(selectedHeaderTab()){
    <!-- My Competitions -->
    @case (0){
    <app-my-competitions />
    }
    <!-- My Matches -->
    @case (1){
    <app-my-matches />
    }
    <!-- My Teams -->
    @case (2){
    <app-my-teams />
    }
    <!-- Default -->
    @default {
    <app-no-result message="NotAvalaibleCompetitions" />
    } }
  </div>
</div>
